export default "__VITE_ASSET__f3a19005__"